import { createContext, useContext, useState } from "react"

type AuthContextType = {
  isLoggedIn: boolean
  isChecking: boolean
  setLoggedIn: (value: boolean) => void
  setChecking: (value: boolean) => void
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isLoggedIn, setLoggedIn] = useState(false)
  const [isChecking, setChecking] = useState(true)

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        isChecking,
        setLoggedIn,
        setChecking,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error("useAuth must be used inside AuthProvider")
  }
  return ctx
}